var map = {
	"./IMG20221103161759.jpg": 713,
	"./portfolio-1.webp": 714,
	"./portfolio-2.jpg": 715,
	"./portfolio-3.jpg": 716,
	"./portfolio-4.jpg": 717,
	"./portfolio-5.jpg": 718,
	"./portfolio-6.jpg": 719,
	"./portfolio-7.jpg": 720,
	"./portfolio-8.jpg": 721,
	"./portfolio-9.jpg": 722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1558;